/*
 * @Description:
 * @Author: lanzhisheng
 * @Date: 2023-03-01 14:09:35
 * @LastEditTime: 2023-03-01 14:16:54
 * @LastEditors: lanzhisheng
 */
import React, { useState, useEffect } from "react";
import { Toast, Empty, NavBar, List } from "antd-mobile";
import "./index.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { domain } from "../interface";

const ListCase = () => {
  let navigate = useNavigate();
  const [data, setData] = useState([]);

  const goDetail = (item) => {
    navigate("/detail?id=" + item.id, { state: { id: item.id } });
  };
  useEffect(() => {
    getList();
  }, []);

  const getList = () => {
    let userId = localStorage.getItem("userId");
    let userName = localStorage.getItem("userName");
    if (userId == null) {
      userId = "ruhua";
      userName = "邢汝华";
    }
    axios
      .post(domain + "/form/find", { userId: userId, userName: userName })
      .then((res) => {
        if (res.status == 200 && res.data) {
          let resData = res.data;
          if (resData.code == 200 && resData.data) {
            setData(resData.data);
          } else {
            setData([]);
            Toast.show({
              content: res.data.message,
            });
          }
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        console.error("corpId err, " + JSON.stringify(error));
      });
  };

  // description={item.content+"【"+item.createdTime+"】"}

  return (
    <div className="pageEdit">
      {/* <NavBar>CASE表单记录</NavBar> */}
      <List header="CASE表单记录" mode="card">
        {data.map((item) => (
          <List.Item
            key={item.id}
            onClick={() => {
              goDetail(item);
            }}
            description={
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    "<font color='black'>" +
                    item.content +
                    "</font> <br /> <font size='2' color='gray'> 状态：" +
                    item.processStatusDesc +
                    "&nbsp;&nbsp;&nbsp;创建时间：" +
                    item.createdTime +
                    "&nbsp;&nbsp;&nbsp;关闭时间：" +
                    item.closeTime +
                    "</font>",
                }}
              ></div>
            }
          >
            <div
              dangerouslySetInnerHTML={{
                __html:
                  " <font size='2' color='black'> (" +item.id+")"+ item.title + "</font>",
              }}
            ></div>
          </List.Item>
        ))}
      </List>
    </div>
  );
};

export default ListCase;
